import type {
  LoanSuccessResponseBodyStage1,
  LoanSuccessResponseBodyStage7,
  LoanSuccessResponseBodyStageOther,
} from '@repo/api/endpoints/loan';
import {
  loanSuccessResponseBodyStage1,
  loanSuccessResponseBodyStage7,
  loanSuccessResponseBodyStageOther,
} from '@repo/api/endpoints/loan';

export const isLoanPositiveResponse = (
  data: unknown,
): data is LoanSuccessResponseBodyStageOther => {
  const result = loanSuccessResponseBodyStageOther.safeParse(data);

  return result.success;
};

export const isLoanPositiveResponseStage1 = (
  data: unknown,
): data is LoanSuccessResponseBodyStage1 => {
  const result = loanSuccessResponseBodyStage1.safeParse(data);

  return result.success;
};

export const isLoanPositiveResponseStage7 = (
  data: unknown,
): data is LoanSuccessResponseBodyStage7 => {
  const result = loanSuccessResponseBodyStage7.safeParse(data);

  return result.success;
};
